import { render, staticRenderFns } from "./RoomNotes.vue?vue&type=template&id=2b3ace72&scoped=true&"
import script from "./RoomNotes.vue?vue&type=script&lang=js&"
export * from "./RoomNotes.vue?vue&type=script&lang=js&"
import style0 from "./RoomNotes.vue?vue&type=style&index=0&id=2b3ace72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ace72",
  null
  
)

export default component.exports